import PropTypes from 'prop-types';
import React from 'react';
import { RowDefinition, ColumnDefinition } from 'griddle-react';
import {
  ButtonToolbar,
  Button,
} from 'react-bootstrap';
import EventIcon from './EventIcon';
import StyledGriddle from '../../../components/StyledGriddle';


const EventType = ({ value }) => <EventIcon eventType={value} />;

class TourRouteTable extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const Toolbar = ({ value }) => (
      <ButtonToolbar>
        <Button name="Edit" data-item={value} onClick={this.props.showEvent}>
          <span className="fa-stack fa-lg" aria-hidden="true">
            <i className="fa fa-square-o fa-stack-2x" />
            <i className="fa fa-pencil" />
          </span>
        </Button>
      </ButtonToolbar>);

    return (
      <StyledGriddle
        data={this.props.formatTourStops()}
      >
        <RowDefinition>
          <ColumnDefinition id="image" title=" " customComponent={EventType} />
          <ColumnDefinition id="date" title="Date" />
          <ColumnDefinition id="name" title="Name" />
          <ColumnDefinition id="location" title="Location" />
          <ColumnDefinition id="driveTime" title="Drive Time" />
          <ColumnDefinition id="notes" title="Notes" />
          <ColumnDefinition id="id" title=" " customComponent={Toolbar} />
        </RowDefinition>
      </StyledGriddle>
    );
  }
}
TourRouteTable.propTypes = {
  tourStops: PropTypes.arrayOf(PropTypes.object).isRequired,
  showEvent: PropTypes.func.isRequired,
  filter: PropTypes.object.isRequired,
};


export default TourRouteTable;



// WEBPACK FOOTER //
// src/routes/tours/components/TourRouteTable.js